import { Component, OnInit } from '@angular/core';
import { Temporal } from '@js-temporal/polyfill';
import { ReportService } from '@proxy/reports';
import { Column } from '../shared/components/metro-table/metro-table.component';
import { SelectOption } from '../shared/components/metro-form-select/metro-form-select.component';
import { SommelierDto } from '@proxy/sommeliers';
import { CommissionReportDto, GetCommissionPagedReportDto } from '@proxy/reports/dto';
import { finalize, take } from 'rxjs';

@Component({
  selector: 'app-reports',
  templateUrl: './settlement-commissions.component.html',
  standalone: false
})
export class SettlementCommissionsComponent implements OnInit {
  selectedSommelier: number | null = null;
  sommelierOptions: SelectOption[] = [];
  sommeliers: SommelierDto[] = [];

  selectedStatus: number | null = null;
  statusOptions: SelectOption[] = [];


  columns: Column[] = [
    { name: 'sommelierName', label: '::Sommelier', width: '20%', textColor: 'text-metro-blue-secondary' },
    { name: 'ordersCount', label: '::TotalOrders', width: '15%', textColor: 'text-metro-blue-secondary' },
    { name: 'totalSales', label: '::TotalSales', width: '15%', textColor: 'text-metro-blue-secondary' },
    { name: 'totalCommission', label: '::TotalCommission', width: '20%', textColor: 'text-metro-blue-secondary' },
  ];

  dateRange: { start: Temporal.PlainDate | null; end: Temporal.PlainDate | null } = {
    start: null,
    end: null,
  };

  reportData: CommissionReportDto[] = [];
  isLoading = false;
  hasLoadedOnce = false;

  currentPage = 1;
  pageSize = 10; // O el tamaño de página que prefieras
  totalCount = 0;


  constructor(private reportService: ReportService) { }
  ngOnInit(): void {
    this.loadSommeliers();
    this.loadOrderStatuses();
  }

  loadReport(): void {
    if (!this.dateRange.start || !this.dateRange.end) {
      return;
    }

    this.isLoading = true;

    const params: GetCommissionPagedReportDto = {
      from: this.dateRange.start.toString(),
      to: this.dateRange.end.toString(),
      sommelierId: this.selectedSommelier,
      status: this.selectedStatus,
      skipCount: (this.currentPage - 1) * this.pageSize,
      maxResultCount: this.pageSize
    };

    this.reportService.getCommissionReportPaged(params)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.hasLoadedOnce = true;
        })
      )
      .subscribe(result => {
        this.reportData = result.items;
        this.totalCount = result.totalCount;
      });
  }


  onPageChange(page: number): void {
    this.currentPage = page;
    this.loadReport();
  }

  onDateRangeChange(range: { start: Temporal.PlainDate; end: Temporal.PlainDate }) {
    this.dateRange = range;
    this.currentPage = 1;

    this.loadReport();
  }

  onSommelierChange(value: number): void {
    this.selectedSommelier = value || null;
    this.currentPage = 1;
    this.loadReport();
  }

  onStatusChange(value: number): void {
    this.selectedStatus = value;
    this.currentPage = 1;
    this.loadReport();
  }

  loadSommeliers(): void {
    this.reportService.getSommeliers().subscribe({
      next: result => {
        this.sommeliers = result;
        this.sommelierOptions = result.map(som => ({
          value: som.id,
          label: som.fullName || som.name || ''
        }));
      }
    });
  }

  loadOrderStatuses(): void {
    this.reportService.getOrderStatuses().subscribe(statuses => {
      this.statusOptions = statuses.map(status => ({
        value: status.value,
        label: status.name,
      }));
    });
  }

  generateExcel() {
    this.isLoading = true;

    const params: GetCommissionPagedReportDto = {
      from: this.dateRange.start.toString(),
      to: this.dateRange.end.toString(),
      sommelierId: this.selectedSommelier,
      status: this.selectedStatus,
      skipCount: (this.currentPage - 1) * this.pageSize,
      maxResultCount: this.pageSize
    };

    const startDate = this.dateRange.start;
    const endDate = this.dateRange.end;
    const formattedStart = `${String(startDate.day).padStart(2, '0')}-${String(startDate.month).padStart(2, '0')}-${startDate.year}`;
    const formattedEnd = `${String(endDate.day).padStart(2, '0')}-${String(endDate.month).padStart(2, '0')}-${endDate.year}`;


    this.reportService.generateCommissionExcel(params, {
      responseType: 'blob'
    } as any)
      .pipe(
        take(1),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe((blob: Blob) => {
        const fileName = `Comisiones_${formattedStart}_al_${formattedEnd}.xlsx`;

        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }



}
